import React from 'react';

export const PrimeEDIcon = () => {
  return (
    <img
      src={'/images/prime/Logos/eDreams_Icon.png'}
      alt={'brand icon'}
      data-testid="brand-icon"
      height={'100%'}
    />
  );
};
